import { Typography } from "antd";
const { Text, Paragraph } = Typography;

export const topfivecolumns = [
    {
        title: 'Spec No.',
        dataIndex: 'spec_concat',
    },
    {
        title: 'FEC',
        dataIndex: 'fec',
    },
    {
        title: 'Raw Finding Rate',
        dataIndex: 'raw_findings_rate',
        render: (ele) => {
            return ele.toFixed(3)
        },
    },
    {
        title: 'Total Effort Hours',
        dataIndex: 'total_effort_hours',
    },
    {
        title: 'Rank Score',
        dataIndex: 'wpm_score',
        render: (ele) => {
            return ele.toFixed(3)
        },
    },
    {
        title: 'Rank',
        dataIndex: 'rank',
    },
];

export const escalatedcolumns = [
    {
        title: 'Spec No.',
        dataIndex: 'spec_concat',
    },
    {
        title: 'FEC',
        dataIndex: 'fec',
    },
    {
        title: 'Raw Finding Rate',
        dataIndex: 'raw_findings_rate',
        render: (ele) => {
            return ele.toFixed(3)
        },
    },
    {
        title: 'Escalated Month',
        dataIndex: 'escalated_on',
        render: (ele) => {
            let strDate = ''
            if (ele) {
                strDate = new Date(ele)
            }
            return String(strDate).slice(4, 15)
        },
    },
    {
        title: 'Rank Score',
        dataIndex: 'wpm_score',
        render: (ele) => {
            return ele.toFixed(3)
        },
    },
    {
        title: 'Rank',
        dataIndex: 'rank',
    },
];

export const items = [
    {
        key: '1',
        label: 'Ranking Process',
        children: <div>
            <div>
                <Paragraph style={{ textAlign: 'left', fontSize: '14px', marginBottom: '7px' }}>
                    <Text style={{ marginRight: '3px', fontWeight: 600 }}>The algorithm currently in use : </Text>
                    <Text>Weighted Product Algorithm</Text>
                </Paragraph>
                <Paragraph style={{ textAlign: 'left', fontSize: '14px', marginBottom: '7px' }}>
                    <Text style={{ marginRight: '3px', fontWeight: 600 }}>Criterias used for Ranking : </Text>
                    <Text>FEC, spec type and repeat interval comparison, regulatory item, raw finding rate, task type, and approximate cost</Text>
                </Paragraph>
                <Paragraph style={{ textAlign: 'left', fontSize: '14px', marginBottom: '7px' }}>
                    <Text style={{ marginRight: '3px', fontWeight: 600 }}>Weights are calculated using : </Text>
                    <Text>Analytic Hierarchy Process</Text>
                </Paragraph>
                <Paragraph style={{ textAlign: 'left', fontSize: '14px', marginBottom: '7px' }}>
                    <Text style={{ marginRight: '3px', fontWeight: 600 }}>Order of Importance of Criterias : </Text> <br />
                    <Text>
                        <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                            <div style={{ width: '20px' }}>1</div><div>FEC Based Score</div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                            <div style={{ width: '20px' }}>2</div><div>Spec Type </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                            <div style={{ width: '20px' }}>3</div><div>Regulatory Item </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                            <div style={{ width: '20px' }}>4</div><div>Raw Findings Rate </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                            <div style={{ width: '20px' }}>5</div><div>Task Type</div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                            <div style={{ width: '20px' }}>6</div><div>Approximate Cost </div>
                        </div>
                    </Text>
                </Paragraph>
                <Paragraph style={{ textAlign: 'left', fontSize: '14px', marginBottom: '7px' }}>
                    <Text style={{ marginRight: '3px', fontWeight: 600 }}>Weights of each parameter : </Text>
                    <Text> FEC Based Score - 0.353, Spec Type - 0.220, Regulatory Item - 0.169, Raw Findings Rate - 0.115, Task Type - 0.079, Approximate Cost - 0.0618</Text>
                </Paragraph>
                <Paragraph style={{ textAlign: 'left', fontSize: '14px', marginBottom: '7px' }}>
                    <Text style={{ marginRight: '3px', fontWeight: 600 }}>Additional Filters : </Text>
                    <Text>For repeating specs, an average of parameters are taken. For same task cards, the maximum approximate cost/lowest repeat interval among them is taken for all calculations</Text>
                </Paragraph>
            </div>
        </div>,
        style: {
            marginBottom: '20px',
            border: 'none',
            backgroundColor: '#fff',
        }
    },
    {
        key: '2',
        label: 'Labor Cost Calculations',
        children: <div>
            <Paragraph style={{ textAlign: 'left', fontSize: '14px', marginBottom: '7px' }}>
                <Text style={{ marginRight: '3px', fontWeight: 600 }}>Parameters used for calculation : </Text> <br />
                <Text>
                    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                        <div style={{ width: '20px' }}>1</div><div>AC on Spec </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                        <div style={{ width: '20px' }}>2</div><div>Average Flight Hrs. per day</div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                        <div style={{ width: '20px' }}>3</div><div>Average Flight Cycles/day </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                        <div style={{ width: '20px' }}>4</div><div>Approx. Labor rate</div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                        <div style={{ width: '20px' }}>5</div><div>Average AC age</div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                        <div style={{ width: '20px' }}>6</div><div>Custom Repeat/Initial</div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                        <div style={{ width: '20px' }}>7</div><div>Effort hours</div>
                    </div>
                </Text>
            </Paragraph>
            <Paragraph style={{ textAlign: 'left', fontSize: '14px', marginBottom: '7px' }}>
                <Text style={{ marginRight: '3px', fontWeight: 600 }}>Calculation Steps : </Text> <br />
                <ul style={{ listStyleType: 'disc', marginLeft: '10px', paddingRight: '15px' }}>
                    <li style={{ textAlign: 'justify', marginBottom: '5px' }}>
                        Custom Initial is used if repeat is unavailable for a specific spec. Otherwise repeat is used
                    </li>
                    <li style={{ textAlign: 'justify', marginBottom: '5px' }}>
                        We use Average AC age, Custom repeat/initial parameters to calculate frequency(number of repetitions in days, years or months) of the specific task in the lifetime of an aircraft
                    </li>
                    <li style={{ textAlign: 'justify', marginBottom: '5px' }}>
                        Then we multiply frequency with AC on spec to get the frequency of checks for the entire fleet in consideration
                    </li>
                    <li style={{ textAlign: 'justify', marginBottom: '5px' }}>
                        Finally, we multiply the results with average labor rate and effort hours to calculate approximate lifetime labor cost
                    </li>
                </ul>
            </Paragraph>
        </div>,
        style: {
            marginBottom: '20px',
            border: 'none',
            backgroundColor: '#fff',
        }
    },
];